import { format } from 'url';

// Determine the url from the current environment
export function url(env = {}) {
  const {
    PUSHBOT_API_PATH: pathname,
    PUSHBOT_API_PORT: apiPort,
    PUSHBOT_API_PROTOCOL: apiProtocol,
    PUSHBOT_API_HOSTNAME: apiHostname = 'localhost',
    PUSHBOT_WEB_PORT: webPort
  } = env;

  const inferredPort =
    !apiPort ||
    (apiPort === webPort && apiHostname === 'localhost') ||
    (apiProtocol === 'https:' && (apiPort || '').toString() === '443') ||
    (apiProtocol === 'http:' && (apiPort || '').toString() === '80');

  const port = inferredPort ? null : apiPort;
  const isRelative = inferredPort && apiHostname === 'localhost';
  const hostname = isRelative ? null : apiHostname;
  const protocol = isRelative ? null : apiProtocol;
  return format({ pathname, port, protocol, hostname });
}



// WEBPACK FOOTER //
// ./js/util/env.js